import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { DocumentContextProvider } from "./contexts/DocumentContext"
import { DocumentDesktopRouter } from "./routers/DocumentDesktopRouter"
import { DocumentMobileRouter } from "./routers/DocumentMobileRouter"

export function L2rAppDocument() {

    const isMobile = useIsMobileDevice()

    return (
        <DocumentContextProvider>
            {isMobile ? <DocumentMobileRouter /> : <DocumentDesktopRouter />}
        </DocumentContextProvider>
    )
}
